import { ChevronRight, ContactRound, Store } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { Prospect } from '../types/crm'
import { formatNumber } from '../utils/format'

export function ProspectCard({ prospect, eventId }: { prospect: Prospect; eventId: string }) {
  return <article className="prospect-card simple-company-card">
    <div className="prospect-head">
      <div><h3>{prospect.name}</h3><p>{prospect.sector || 'Secteur à compléter'} · {prospect.country || 'Pays à compléter'}</p></div>
      <span className={`priority priority-${prospect.priority}`}>{prospect.priority}</span>
    </div>
    <div className="company-card-count"><Store size={16} />{formatNumber(prospect.storeCount)} magasins</div>
    <dl className="compact-details">
      <div><dt>Contact identifié</dt><dd>{prospect.contactIdentifiedSummary || <em>Aucun contact renseigné</em>}</dd></div>
      <div><dt>Contact à identifier</dt><dd>{prospect.contactToIdentify || '—'}</dd></div>
      <div><dt>Action salon</dt><dd>{prospect.eventAction || '—'}</dd></div>
    </dl>
    <Link className="edit-company-link" to={`/companies/${prospect.id}?eventId=${eventId}`}><ContactRound size={17} />Modifier les informations<ChevronRight size={17} /></Link>
  </article>
}
